import React from 'react';
import { bool, string } from 'prop-types';
import { Alert } from '@one-thd/sui-atomic-components';
import { SignInLink } from '../signInLink/SignInLink';
import { MAP_POLICY_VERBIAGE } from '../../constants';

export const MessaggingSummary = ({ mapPolicy, haveSpecialPriceIfAuthProduct, isCustomerIdentified }) => {
  const isAuthPriceRequired = !isCustomerIdentified && haveSpecialPriceIfAuthProduct;
  return (
    <>
      {(mapPolicy) && (
        <Alert status="info">
          {mapPolicy ? (
            <>
              {MAP_POLICY_VERBIAGE[isAuthPriceRequired ? 'showSpecialPriceIfAuth' : 'showPriceInCart']}
              {(isAuthPriceRequired) && (
                <>
                  <SignInLink />
                </>
              )}
            </>
          ) : (
            MAP_POLICY_VERBIAGE.showPriceInCart
          )}
        </Alert>
      )}
    </>
  );
};

MessaggingSummary.propTypes = {
  mapPolicy: bool,
  isCustomerIdentified: bool,
  haveSpecialPriceIfAuthProduct: bool
};

MessaggingSummary.defaultProps = {
  mapPolicy: false,
  isCustomerIdentified: false,
  haveSpecialPriceIfAuthProduct: false
};
